var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import client from 'api/environment';
import UPDATE_USER_AVATAR from 'api/mutations/UPDATE_USER_AVATAR';
import GET_CURRENT_TENANT from 'api/queries/GET_CURRENT_TENANT';
import PROFILE from 'api/queries/PROFILE';
const initialState = {
    data: null,
    tennant: null,
    status: {
        fetch: 'idle',
        fetchTennant: 'idle',
    },
    error: {
        fetch: null,
        fetchTennant: null,
    },
    refetchFlags: {
        fetch: false,
        fetchTennant: false,
    },
};
export const fetchUserProfile = createAsyncThunk('user/fetchUserProfile', (_, { rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield client.query({
            query: PROFILE,
            fetchPolicy: 'network-only',
        });
        return response.data.me;
    }
    catch (error) {
        const apolloError = error;
        return rejectWithValue(apolloError.message);
    }
}));
export const fetchCurrentTennant = createAsyncThunk('user/fetchCurrentTennant', (_, { rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield client.query({
            query: GET_CURRENT_TENANT,
            fetchPolicy: 'network-only',
        });
        return response.data.me.currentTenant;
    }
    catch (error) {
        const apolloError = error;
        return rejectWithValue(apolloError.message);
    }
}));
export const updateUserAvatar = createAsyncThunk('user/updateUserAvatar', ({ avatar, userId }, { rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield client.mutate({
            mutation: UPDATE_USER_AVATAR,
            variables: {
                avatar,
                userId,
            },
        });
        return response.data.updateUser.user;
    }
    catch (error) {
        const apolloError = error;
        return rejectWithValue(apolloError.message);
    }
}));
const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        logout: (state) => {
            state.data = null;
            state.tennant = null;
        },
        updateUserAvatarStore: (state, action) => {
            state.data = Object.assign(Object.assign({}, state.data), { avatar: action.payload });
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchUserProfile.pending, (state) => {
            state.status.fetch = 'loading';
            state.refetchFlags.fetch = false;
        })
            .addCase(fetchUserProfile.fulfilled, (state, action) => {
            state.data = {
                id: action.payload.id,
                email: action.payload.email,
                username: action.payload.username,
                avatar: action.payload.avatar,
                maintenance: action.payload.maintenance,
            };
            state.status.fetch = 'succeeded';
        })
            .addCase(fetchUserProfile.rejected, (state, action) => {
            state.status.fetch = 'failed';
            state.error.fetch = action.error.message || 'Error fetching components';
        })
            .addCase(fetchCurrentTennant.pending, (state) => {
            state.status.fetchTennant = 'loading';
            state.refetchFlags.fetchTennant = false;
        })
            .addCase(fetchCurrentTennant.fulfilled, (state, action) => {
            state.tennant = action.payload;
            state.status.fetchTennant = 'succeeded';
        })
            .addCase(fetchCurrentTennant.rejected, (state, action) => {
            state.status.fetchTennant = 'failed';
            state.error.fetchTennant = action.error.message || 'Error fetching components';
        })
            .addCase(updateUserAvatar.pending, (state) => {
            state.status.update = 'loading';
            state.refetchFlags.fetch = false;
        })
            .addCase(updateUserAvatar.fulfilled, (state, action) => {
            state.data = Object.assign(Object.assign({}, state.data), { avatar: action.payload.avatar });
            state.status.update = 'succeeded';
        })
            .addCase(updateUserAvatar.rejected, (state, action) => {
            state.status.update = 'failed';
            state.error.fetch = action.error.message || 'Error fetching components';
        });
    },
});
export const { logout, updateUserAvatarStore } = userSlice.actions;
export const selectUserProfileDataData = (state) => state.user.data;
export const selectTennantData = (state) => state.user.tennant;
export const selectUserProfileDataStatus = (state) => state.user.status.fetch;
export default userSlice.reducer;
